/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable-next-line react/prop-types */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  SafeAreaView,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import {
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  ScrollView,
  StyleSheet,
} from 'react-native';
import {
  Gesture,
  GestureDetector,
  GestureHandlerRootView,
} from 'react-native-gesture-handler';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';

import Colors from '@global/colors';
import { isWeb, isAndroid, isNative, isIphoneX } from '@global/screens';

import Modal from '@components/modal/Modal';
import ImageDefault from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';

import { hideImage } from '@/store/global';

const dimension = Dimensions.get('window');

const ModalImage = (props) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.global.popupImage);
  const sourceImage = data.url || '';
  const isMultipleImage = data?.isMultiple || false;
  const allImages = data?.allImage || [];
  const isMultipleImageRender = isMultipleImage && allImages.length > 0;

  const [currentIndex, setCurrentIndex] = useState(0);

  const currentImage = allImages[currentIndex] || '';

  const handleNext = () => {
    if (currentIndex < allImages.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  let popupImage = data.url || '';
  if (typeof popupImage == 'object') {
    popupImage = data.url.uri || '';
  }
  const popupText = data.text || '';
  const onEdit = data.onEdit || false;
  // eslint-disable-next-line react/prop-types
  const { maxWidth, width, showDefault } = props;
  const disableCDN = data.disableCDN || false;

  const show = popupImage ? true : false;

  const insets = useSafeAreaInsets();
  const screenHeight = isWeb
    ? 'auto'
    : dimension.height - insets.top - insets.bottom - (isAndroid ? 50 : 0);
  const maxHeight = isWeb ? dimension.height - 100 : 0;
  const [imageHeight, setImageHeight] = useState(0);
  const [mobileHeight, setMobileHeight] = useState(0);

  const onLayout = async (e) => {
    const native = e.nativeEvent;
    await Image.getSize(
      popupImage,
      (width, height) => {
        let realWidth = 0;
        if (native) {
          if (!isNative && native.target && native.target.clientWidth) {
            realWidth = native.target.clientWidth;
          }
          if (isNative && native.layout && native.layout.width) {
            realWidth = native.layout.width;
          }
        }
        // const getRatio = (a, b) => (b == 0) ? a : getRatio (b, a % b)
        const getRatio = (a, b) => {
          for (let result = b; result > 1; result--) {
            if (a % result == 0 && b % result == 0) {
              a = a / result;
              b = b / result;
            }
          }
          return { width: a, height: b };
        };
        const ratio = getRatio(width, height);
        const finalWidthRatio = realWidth / ratio.width;
        const finalHeightRatio = finalWidthRatio * ratio.height;
        // Get the Actual Size Image
        const mobileRatio = dimension.width / width;
        const mobileHeight = height * mobileRatio;
        setMobileHeight(mobileHeight);
        setImageHeight(finalHeightRatio ? finalHeightRatio : 250);
      },
      (err) => console.log(err),
    );
  };

  const ImageNavigation = () => (
    <View
      style={[styles.imageContainer, !isWeb && styles.imageContainerMobile]}>
      {!data?.noArrow && (
        <TouchableOpacity
          testID="modal-image-prev-btn"
          style={[styles.arrowButton, isWeb && styles.arrowButtonWeb]}
          onPress={handlePrev}>
          <ImageDefault
            style={styles.arrowIcon}
            width={35}
            height={35}
            source={
              currentIndex === 0
                ? require('@assets/img/icons/disable-arrow-left.svg')
                : require('@assets/img/icons/enable-arrow-left.svg')
            }
            svg
          />
        </TouchableOpacity>
      )}
      <ImageDefault
        testID="modal-image-main"
        style={[styles.mainImage, isWeb && styles.mainImageWeb]}
        width={isWeb ? 750 : 180}
        height={isWeb ? 560 : 130}
        source={{ uri: currentImage }}
      />
      {!data?.noArrow && (
        <TouchableOpacity
          testID="modal-image-next-btn"
          style={[styles.arrowButton, isWeb && styles.arrowButtonWeb]}
          onPress={handleNext}>
          <ImageDefault
            style={styles.arrowIcon}
            width={35}
            height={35}
            source={
              currentIndex + 1 === allImages.length
                ? require('@assets/img/icons/disable-arrow-right.svg')
                : require('@assets/img/icons/enable-arrow-right.svg')
            }
            svg
          />
        </TouchableOpacity>
      )}
    </View>
  );

  const ImageMobile = () => {
    const MIN_SCALE = 1;
    const MAX_SCALE = 3;
    const baseWidth = Math.min(dimension.width - 40, 350);
    const baseHeight = baseWidth;

    const scale = useSharedValue(1);
    const savedScale = useSharedValue(1);
    const translateX = useSharedValue(0);
    const translateY = useSharedValue(0);
    const savedTranslateX = useSharedValue(0);
    const savedTranslateY = useSharedValue(0);

    const resetZoom = () => {
      'worklet';
      scale.value = withTiming(1);
      savedScale.value = 1;
      translateX.value = withTiming(0);
      translateY.value = withTiming(0);
      savedTranslateX.value = 0;
      savedTranslateY.value = 0;
    };

    const clamp = (value, lowerBound, upperBound) => {
      'worklet';
      return Math.min(Math.max(value, lowerBound), upperBound);
    };

    const clampTranslate = (value, nextScale, size) => {
      'worklet';
      if (nextScale <= 1) {
        return 0;
      }
      const bound = ((nextScale - 1) * size) / 2;
      if (bound <= 0) {
        return 0;
      }
      return clamp(value, -bound, bound);
    };

    const pinchGesture = Gesture.Pinch()
      .onStart(() => {
        savedScale.value = scale.value;
      })
      .onUpdate((event) => {
        const rawScale = savedScale.value * event.scale;
        const nextScale = clamp(rawScale, MIN_SCALE, MAX_SCALE);
        scale.value = nextScale;
        translateX.value = clampTranslate(
          translateX.value,
          nextScale,
          baseWidth,
        );
        translateY.value = clampTranslate(
          translateY.value,
          nextScale,
          baseHeight,
        );
      })
      .onEnd(() => {
        resetZoom();
      });

    const panGesture = Gesture.Pan()
      .onStart(() => {
        savedTranslateX.value = translateX.value;
        savedTranslateY.value = translateY.value;
      })
      .onUpdate((event) => {
        if (scale.value <= 1) {
          translateX.value = 0;
          translateY.value = 0;
          return;
        }
        const nextX = savedTranslateX.value + event.translationX;
        const nextY = savedTranslateY.value + event.translationY;
        translateX.value = clampTranslate(nextX, scale.value, baseWidth);
        translateY.value = clampTranslate(nextY, scale.value, baseHeight);
      })
      .onEnd(() => {
        resetZoom();
      });

    const composedGesture = Gesture.Simultaneous(pinchGesture, panGesture);

    const animatedStyles = useAnimatedStyle(() => ({
      transform: [
        { translateX: translateX.value },
        { translateY: translateY.value },
        { scale: scale.value },
      ],
    }));

    useEffect(() => {
      scale.value = 1;
      savedScale.value = 1;
      translateX.value = 0;
      translateY.value = 0;
      savedTranslateX.value = 0;
      savedTranslateY.value = 0;
    }, [currentImage]);

    return (
      <View
        style={[
          styles.imageContainer,
          styles.imageContainerMobile,
          { paddingHorizontal: 20 },
        ]}>
        <GestureDetector gesture={composedGesture}>
          <Animated.View
            style={[
              styles.zoomImageWrapper,
              { width: baseWidth, height: baseHeight },
              animatedStyles,
            ]}>
            <ImageDefault
              testID="modal-image-main-mobile"
              width={baseWidth}
              height={baseHeight}
              style={{ width: '100%', height: '100%', resizeMode: 'contain' }}
              source={currentImage ? { uri: currentImage } : ''}
            />
          </Animated.View>
        </GestureDetector>
      </View>
    );
  };

  const ThumbnailList = () => (
    <ScrollView
      horizontal
      showsHorizontalScrollIndicator={false}
      style={[styles.scrollContainer, !isWeb && styles.scrollContainerMobile]}>
      {!data?.noArrow &&
        allImages.map((image, index) => (
          <TouchableOpacity
            testID={`modal-image-thumbnail-${index}`}
            key={index}
            onPress={() => setCurrentIndex(index)}>
            <ImageDefault
              style={[
                styles.thumbnail,
                isWeb && styles.thumbnailWeb,
                currentIndex === index && styles.selectedThumbnail,
              ]}
              source={{ uri: image }}
            />
          </TouchableOpacity>
        ))}
    </ScrollView>
  );

  const HeaderThumbnail = () => (
    <View>
      <View style={styles.headerContainer}>
        <SociollaText
          testID="modal-image-counter"
          style={styles.textBold}
          onPress={() => dispatch(hideImage())}>
          {`${currentIndex + 1} / ${allImages.length}`}
        </SociollaText>
        <ImageDefault
          style={styles.icon}
          width={14}
          height={14}
          source={require('@assets/img/icons/gallery.svg')}
          svg
        />
      </View>
      <View
        style={[styles.closeButtonContainer, isWeb && styles.closeButtonWeb]}>
        <TouchableOpacity
          testID="modal-image-close-btn"
          onPress={() => dispatch(hideImage())}>
          <ImageDefault
            style={styles.closeIcon}
            source={
              isWeb
                ? require('@assets/img/icons/cross-circle.svg')
                : require('@assets/img/icons/x-close.svg')
            }
            width={20}
            height={20}
            svg
          />
        </TouchableOpacity>
      </View>
    </View>
  );

  const MultipleImageContent = () => (
    <View style={[styles.container, isWeb && styles.webContainer]}>
      {HeaderThumbnail()}
      {!isWeb && <ImageMobile />}
      {isWeb && ImageNavigation()}
      {ThumbnailList()}
    </View>
  );

  const RenderMultipleImage = () => (
    <Modal
      visible={show}
      fullPage={true}
      transparent={true}
      width={1000}
      animationType={isWeb ? 'fade' : 'slide'}
      onClose={() => dispatch(hideImage())}>
      {!isWeb ? (
        <GestureHandlerRootView style={{ flex: 1 }}>
          <MultipleImageContent />
        </GestureHandlerRootView>
      ) : (
        <MultipleImageContent />
      )}
    </Modal>
  );

  const RenderNonMultipleImage = () => (
    <Modal
      visible={show}
      fullPage={true}
      maxWidth={maxWidth ? maxWidth : '100%'}
      width={width ? width : 600}
      animationType={isWeb ? 'fade' : 'slide'}
      onClose={() => dispatch(hideImage())}>
      <SafeAreaView style={{ flex: 0, backgroundColor: Colors.black }} />
      <SafeAreaView style={{ flex: 1, backgroundColor: Colors.black }}>
        <View
          style={{ position: 'relative', width: '100%' }}
          onLayout={onLayout}>
          <View
            style={{
              width: '100%',
              position: 'absolute',
              top: isIphoneX ? 50 : 0,
              left: 0,
              zIndex: 1,
              elevation: 1,
            }}>
            <TouchableOpacity
              testID="modal-image-close-btn"
              style={{ padding: 20 }}
              onPress={() => dispatch(hideImage())}>
              <ImageDefault
                width={16}
                height={16}
                style={{ width: 16, height: 16 }}
                svg={true}
                source={require('@assets/img/icons/close-white.svg')}
              />
            </TouchableOpacity>
          </View>
          <View
            style={{
              width: '100%',
              height: screenHeight,
              padding: isWeb ? 15 : 0,
              paddingTop: 55,
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              ...(isWeb ? { maxHeight: maxHeight } : {}),
            }}>
            <ImageDefault
              testID="modal-image-main"
              width={isWeb ? '100%' : dimension.width}
              height={isWeb ? imageHeight : mobileHeight}
              style={{
                width: isWeb ? '100%' : dimension.width,
                height: isWeb ? imageHeight : mobileHeight,
                maxHeight: isWeb ? maxHeight - 65 : screenHeight,
              }}
              source={sourceImage}
              showDefault={showDefault ? true : false}
              disableCDN={disableCDN ? true : false}
            />
          </View>
          {popupText || onEdit ? (
            <View
              style={{
                position: 'absolute',
                bottom: 0,
                right: 0,
                left: 0,
                paddingVertical: 15,
                paddingHorizontal: 25,
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: Colors.black4,
              }}>
              <SociollaText style={{ fontSize: 14, color: Colors.white }}>
                {popupText}
              </SociollaText>
              {onEdit ? (
                <TouchableOpacity
                  style={{
                    padding: 20,
                    position: 'absolute',
                    right: 5,
                    zIndex: 1,
                    elevation: 2,
                  }}
                  onPress={() => {
                    onEdit();
                    dispatch(hideImage());
                  }}>
                  <ImageDefault
                    width={16}
                    height={16}
                    style={{ width: 16, height: 16 }}
                    svg={true}
                    source={require('@assets/img/icons/edit-grey.svg')}
                  />
                </TouchableOpacity>
              ) : (
                false
              )}
            </View>
          ) : (
            false
          )}
        </View>
      </SafeAreaView>
    </Modal>
  );

  return isMultipleImageRender
    ? RenderMultipleImage()
    : RenderNonMultipleImage();
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginTop: 0,
    backgroundColor: '#171D29',
  },
  webContainer: {
    marginTop: isWeb ? 30 : 60,
    backgroundColor: 'transparent',
  },
  headerContainer: {
    display: 'flex',
    padding: 20,
    marginTop: !isWeb ? 90 : 0,
    position: 'absolute',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    width: '100%',
    flexDirection: 'row',
  },
  textBold: {
    fontSize: 14,
    color: Colors.white,
  },
  icon: {
    width: 14,
    height: 14,
    marginLeft: 8,
  },
  closeButtonContainer: {
    padding: 20,
    position: 'relative',
    marginTop: !isWeb ? 40 : 0,
  },
  closeButtonWeb: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginRight: isWeb ? 170 : 0,
    top: 0,
    zIndex: 1,
  },
  closeIcon: {
    width: 25,
    height: 25,
  },
  imageContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: dimension.height * 0.7,
  },
  imageContainerMobile: {
    marginTop: 20,
  },
  arrowButton: {
    padding: 20,
  },
  arrowButtonWeb: {
    padding: 60,
  },
  arrowIcon: {
    width: 35,
    height: 35,
  },
  mainImage: {
    width: 180,
    height: 130,
    marginVertical: 20,
    resizeMode: 'contain',
  },
  mainImageWeb: {
    width: 750,
    height: 560,
    resizeMode: 'contain',
  },
  scrollContainer: {
    marginLeft: isWeb ? 90 : 0,
    paddingLeft: isWeb ? 90 : 0,
    paddingHorizontal: 10,
    marginTop: -30,
    paddingBottom: 20,
  },
  scrollContainerMobile: {
    marginBottom: 200,
  },
  thumbnail: {
    marginHorizontal: 5,
    borderWidth: 3,
    borderColor: 'transparent',
    width: 50,
    height: 50,
    borderRadius: 8,
  },
  thumbnailWeb: {
    width: 100,
    height: 100,
  },
  selectedThumbnail: {
    borderColor: '#00B5DF',
  },
  zoomImageWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
});

export default React.memo(ModalImage, (prev, next) => prev == next);
